export default __webpack_public_path__ + "static/media/1.d46145e5.png";